import { SearchTerm } from './SearchTerm';

const PresetControllerSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "devName",
        translationKey: "name"
    },
    {
        heading: "Fixed Address",
        accessor: "fixedAddress",
        searchOnName: "devFixedAddr",
        translationKey: "fixedAddress"
    },
    {
        heading: "IP Address",
        accessor: "ipAddress",
        searchOnName: "devIpAddress",
        translationKey: "ipAddress"
    },
    {
        heading: "Type",
        accessor: "type",
        searchOnName: "unitType.trnName",
        translationKey: "type"
    },
];

export default PresetControllerSearch;
